import React, { Component } from 'react';
import Body from './reuseable/Body';
import Header from './reuseable/Header';

class Faq extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    componentDidMount() {
        // require('../assets/scss/style.scss')
    }
    render() {
        return (
            <>
                <Header {...this.props} type='back' title='F.A.Q' />
                <Body {...this.props} />
            </>
        )
    }
}
export default Faq;